<div id="conditionDefaultForm" #conditonBasicForm>
    <form [formGroup]="conditionalFieldForm" id="reporting-set-data-field">
        <div class="input-field">
            <label for="field-type-dropdown" id="operator-type-label" cvLocalizedText langSection="ETL_Reporting_Set"
                langKey="Operator">OPERATOR </label><span class="operator-required">
                * </span>
            <cxone-singleselect-dropdown id="operator-type-dropdown" formControlName="operatorDropdown"
                [placeholder]="operatorPlaceholderText" [label]="'label'" [isRequired]="true" [primaryKey]="'label'"
                [options]="operatorTypes" [showFooter]="false" [search]="false" (selectionChanged)="formValueChanged()">
            </cxone-singleselect-dropdown>
        </div>

        <div class="input-field">
            <label for="positive-field" cvLocalizedText langSection="ETL_Reporting_Set" langKey="Postive_Result">
                POSITIVE RESULT
            </label> <span class="field-required"> * </span>
            <div class="row list-item"
                *ngIf="_parentData?.hasOwnProperty('positive') && _parentData?.positive?.length > 0">
                <ng-container *ngTemplateOutlet="addedList; context: { source: {fieldType: 'positive'} }">
                </ng-container>
            </div>
            <div class="row list-item"
                *ngIf="!_parentData?.hasOwnProperty('positive') || _parentData?.positive?.length === 0">
                <ng-container *ngTemplateOutlet="emptyList; context: { source: {fieldType: 'positive'} }">
                </ng-container>
            </div>
        </div>

        <div class="input-field">
            <label for="negative-field" cvLocalizedText langSection="ETL_Reporting_Set" langKey="Negative_Result">
                NEGATIVE RESULT
            </label> <span class="field-required"> * </span>
            <div class="row list-item"
                *ngIf="_parentData?.hasOwnProperty('negative') && _parentData?.negative?.length > 0">
                <ng-container *ngTemplateOutlet="addedList; context: { source: {fieldType: 'negative'} }">
                </ng-container>
            </div>
            <div class="row list-item"
                *ngIf="!_parentData?.hasOwnProperty('negative') || _parentData?.negative?.length === 0">
                <ng-container *ngTemplateOutlet="emptyList; context: { source: {fieldType: 'negative'} }">
                </ng-container>
            </div>
        </div>
    </form>
    <div class="input-field">
        <label for="comparison-field" cvLocalizedText langSection="ETL_Reporting_Set" langKey="Comparisons">
            COMPARISONS
        </label> <span class="field-required"> * </span>
        <div class="row list-item" *ngFor="let item of _parentData?.comparisons">
            <ng-container *ngTemplateOutlet="addedList; context: { source: {item: item, fieldType: 'comparisons'} }">
            </ng-container>
        </div>
        <div class="row list-item">
            <ng-container *ngTemplateOutlet="emptyList; context: { source: {fieldType: 'comparisons'} }">
            </ng-container>
        </div>
    </div>
</div>
<div hidden="true" #comparisonFormRef id="comparision-form">
    <div *ngIf="comparisonForm != undefined">
        <button class="button back-btn" #internalBack id="internal-back"
            (click)="backBtn(conditonBasicForm, comparisonFormRef)" cvLocalizedText langSection="ETL_Reporting_Set"
            langKey="Back">Back</button>
        <cv-comparison-field [comparisonForm]="comparisonForm" (formChanged)="formValueChanged()"
            (addBtnClick)="addNewFieldFormComparison($event, conditonBasicForm, comparisonFormRef)"
            (editInputClick)="EditFieldFormComparison($event, conditonBasicForm, comparisonFormRef)"></cv-comparison-field>
    </div>
</div>
<ng-template #addedList let-source="source">
    <div class="col-10 add-field-box">
        <p *ngIf="source?.fieldType == 'comparisons'" class="row add-field-box-color ellipsis-text" title="{{source?.item?.field1.length
            > 0 ? source?.item?.field1[0]?.name : ''}} {{source?.item?.comparisonType?.value}}
            {{source?.item?.field2.length > 0 ? source?.item?.field2[0]?.name : ''}}">
            {{source?.item?.field1.length
            > 0 ? source?.item?.field1[0]?.name : ''}} {{source?.item?.comparisonType?.value}}
            {{source?.item?.field2.length > 0 ? source?.item?.field2[0]?.name : ''}}</p>
        <p *ngIf="source?.fieldType != 'comparisons'" class="row add-field-box-color ellipsis-text"
            title="{{_parentData[source?.fieldType][0]?.name}}">
            {{_parentData[source?.fieldType][0]?.name}}</p>
    </div>
    <div class="col-2 cursor-pointer icon-container">
        <svg *ngIf="source?.fieldType == 'comparisons'" class="icon edit-icon"
            (click)="editExist(source?.item, conditonBasicForm, comparisonFormRef)">
            <use href="../App_Themes/CXone/icons/edit.svg#edit"></use>
        </svg>
        <svg *ngIf="source?.fieldType != 'comparisons'" class="icon edit-icon"
            (click)="editInput(_parentData[source?.fieldType][0])">
            <use href="../App_Themes/CXone/icons/edit.svg#edit"></use>
        </svg>
    </div>
</ng-template>
<ng-template #emptyList let-source="source">
    <div class="col-10 add-field-box">
        <p class="row add-field-box-list" cvLocalizedText langSection="ETL_Reporting_Set"
            langKey="Input_Field_Placeholder">Add input</p>
    </div>
    <div class="col-2 cursor-pointer icon-container">
        <svg *ngIf="source?.fieldType == 'comparisons'" class="icon add-icon icon-14"
            (click)="comparisionClick(conditonBasicForm, comparisonFormRef)"
            [class.disable-div]="!hasValidComparison()">
            <use href="../App_Themes/CXone/icons/add.svg#add"></use>
        </svg>
        <svg *ngIf="source?.fieldType != 'comparisons'" class="icon add-icon icon-14"
            (click)="addNewField(source?.fieldType)">
            <use href="../App_Themes/CXone/icons/add.svg#add"></use>
        </svg>
    </div>
</ng-template>